// Route shell only. Implementation lives at src/dev/admin.test.impl.tsx
// and is loaded ONLY in dev — `import.meta.env.PROD` is statically replaced
// at build time, so Rollup tree-shakes the dynamic import in production
// and no impl chunk ships. `beforeLoad` returns 404 in prod as a backstop.
import { createFileRoute, notFound, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/test")({
  beforeLoad: () => {
    if (import.meta.env.PROD) throw notFound();
  },
  component: import.meta.env.PROD
    ? () => null
    : lazyRouteComponent(() => import("@/dev/admin.test.impl")),
  head: () => ({
    meta: [{ name: "robots", content: "noindex, nofollow" }],
  }),
});
